import { createContext, useContext } from 'react'

export const RowContext = createContext(null)
export const useRow = () => useContext(RowContext);
